import {
  Badge,
  BadgeProps,
  Button,
  Card as MuiCard,
  CardContent,
  Chip as MuiChip,
  Drawer as MuiDrawer,
  styled,
  Tab as MuiTab,
} from '@mui/material';

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'mode',
})<BadgeProps & { mode?: 'orange' | 'green' | 'grey' }>(({ theme, mode }) => {
  const background =
    mode === 'orange'
      ? theme.palette.accentColor.main
      : mode === 'green'
      ? theme.palette.green.main
      : theme.palette.grey[700];
  return {
    '& .MuiBadge-badge': {
      right: -12,
      top: 10,
      background,
      color: '#fff',
      fontWeight: 600,
      width: 18,
      height: 18,
    },
  };
});

export const Tab = styled(MuiTab)({
  minWidth: 40,
});

export const Drawer = styled(MuiDrawer)(({ theme }) => ({
  width: 312,
  flexShrink: 0,
  ['& .MuiDrawer-paper']: {
    width: 312,
    boxSizing: 'border-box',
    background: theme.palette.grey[500],
  },
}));

export const StopWatch = styled('time')({
  fontWeight: 500,
  opacity: 0.64,
});

export const CardContentNoPadding = styled(CardContent, {
  shouldForwardProp: (prop) => prop !== 'smallerPaddings',
})<{ smallerPaddings?: boolean }>(({ smallerPaddings }) => ({
  padding: smallerPaddings ? 13 : 16,
  '&:last-child': {
    paddingBottom: smallerPaddings ? 13 : 16,
  },
}));

export const AnomalyButton = styled(Button)(({ theme }) => ({
  width: 264,
  height: 32,
  padding: '8px 12px',
  border: `1px solid ${theme.palette.grey[600]}`,
  backgroundColor: '#fff',
  borderRadius: 2,
  outline: 'none',
  fontSize: 12,
  textTransform: 'none',
}));

export const Chip = styled(MuiChip)({
  backgroundColor: '#d7f0d3',
  color: '#819f7c',
  fontSize: 10,
  fontWeight: 700,
  textTransform: 'uppercase',
  height: 16,
  borderRadius: 3,
});

export const Card = styled(MuiCard, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled: boolean }>(({ theme, disabled }) => ({
  cursor: disabled ? 'default' : 'pointer',
  backgroundColor: disabled ? theme.palette.grey[600] : '#fff',
  opacity: disabled ? 0.4 : 1,
}));
